export default __webpack_public_path__ + "static/media/production-machines.bbc7db5d.PNG";